import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import 'auth0-js/build/auth0'
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js